import vm from '@/main'  ///导入VUE实例


///地址传递 倒计时计数，并改变状态（用于短信验证码按钮的状态变化和倒计时显示）
const countSHandle = (phoneCode) => {
    let StarTime = phoneCode.countS;
    phoneCode.state = false;
    const countSid = setInterval(() => {
        phoneCode.countS--;
        if (phoneCode.countS <= 0) {
            phoneCode.state = true;
            phoneCode.countS = StarTime;
            clearInterval(countSid);
        }
    }, 1000)
}


///检查11位手机号码是否合法 不合法返回  false
const checkCellPhoneNumber = (number) => {

    let flag = false;
    let message = "";
    //const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
    const myreg = /^1[3-9][0-9]\d{8}$/;

    if (number == '') {
        // console.log("手机号码不能为空");
        message = "手机号码不能为空！";
    }
    else if (number.length != 11) {
        //console.log("请输入11位手机号码！");
        message = "请输入有效的11位手机号码!";
    }
    else if (!myreg.test(number)) {
        //console.log("请输入有效的手机号码！");
        message = "请输入有效的手机号码！";
    }
    else {
        flag = true;
    }

    if (message != "") {
        vm.$toast(message);
    }
    return flag;
}
///检查子账号是否合法 不合法返回  false
const checkSonAccountNumber = (number) => {
    let flag = false;
    let message = "";
    const myPattern = new RegExp("^[a-zA-Z]"); // 以英文字母开头
    const reg = /[\u4e00-\u9fa5]/g;  ////是否包含中文
    if (number == '') {
        // console.log("手机号码不能为空");
        message = "子账号不能为空！";
    } else if (number.length < 6 || number.length > 18) {
        //console.log("请输入11位手机号码！");
        message = "子账号最少6位，最多18位！";
    }
    else if (!myPattern.exec(number)) {
        message = "子账号必须以英文字母开头！";
    }else if (number.indexOf(" ") != -1) { ///判断字符串中是否包含空格
        console.log(number)
        vm.$toast("子账号中不能包含空格！");
    }else if(reg.test(number)){
        vm.$toast("子账号中不能包含中文！");
    }
    else {
        flag = true;
    }


    if (message != "") {
        vm.$toast(message);
    }
    return flag;
}
///检查密码是否合法//限制6-24位 包含最少6 最多24 
const checkPassword = (password) => {
    console.log(password)
    // const regNull = /(^\s*)|(\s*$)/g;  
    let flag = true;
    if (password.length > 24 || password.length < 6) {
        flag = false;
        vm.$toast("请输入最少6位，最多24位的密码！");
    } else if (password.indexOf(" ") != -1) { ///判断字符串中是否包含空格
        flag = false;
        console.log(password)
        vm.$toast("密码中不能包含空格！");
    }
    return flag;
}
///检查两次输入的密码的是否一致
const checkPasswordC = (password, passwordC) => {
    if (password === passwordC) {
        return true;
    }
    vm.$toast("两次输入的密码不一致！");
    return false;
}
///检查地址是否选择
const checkCityCode = (cityCode) => {
    if (cityCode === '') {
        vm.$toast("请先选择所在城市信息！");
        return false
    }
    return true;
}
///检查手机验证码是否输入正确
const checkImgCode = (userCode, serverCode) => {
    if (userCode === "") {
        vm.$toast("请输入图片校验码！");
        return false;
    }
    else if (userCode != serverCode) {
        vm.$toast("图片校验码输入错误，请点击图片刷新后重试！");
        return false;
    }
    return true;

}
///检查手机验证码是否填写
const checkCallphoneCrc = (phoneCrc) => {
    if (phoneCrc === "") {
        vm.$toast("手机验证码不能为空！");
        return false;
    }
    return true;
}

///总的检查  主账号注册
const checkUserData = (data) => {
    if (!checkCellPhoneNumber(data.telePhone)) return false;
    if (!checkPassword(data.Password)) return false;
    if (!checkPasswordC(data.Password, data.CPassword)) return false;
    if (!checkCityCode(data.cityCode)) return false;
    if (!checkImgCode(data.userCheckCode, data.imgCheck.Servercode)) return false;
    if (!data.checkState) {
        vm.$toast("请先阅读用户使用协议，并勾选同意！");
        return false;
    }
    return true;
}
///总的检查 主账号修改密码 
const checkUserDataChangePassword = (data) => {
    // if (!checkCellPhoneNumber(data.telePhone)) return false; // 代号 20231204-1
    if (!checkPassword(data.Password)) return false;
    if (!checkPasswordC(data.Password, data.CPassword)) return false;
    if (!checkImgCode(data.userCheckCode, data.imgCheck.Servercode)) return false;

    return true;
}





export {
    countSHandle,
    checkCellPhoneNumber,
    checkPassword,
    checkPasswordC,
    checkCityCode,
    checkImgCode,
    checkUserData,
    checkCallphoneCrc,
    checkUserDataChangePassword,
    checkSonAccountNumber


}
